// src/hooks/useCurrencySymbol.js

const useCurrencySymbol = (currency) => {
  switch (currency?.toUpperCase()) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    case "PLN":
      return "zł";
    case "NOK":
      return "kr";
    case "SEK":
      return "kr";
    case "DKK":
      return "kr";
    case "CHF":
      return "CHF";
    default:
      return ""; // fallback if unknown
  }
};

export default useCurrencySymbol;
